
import { Component, Vue, Watch } from 'vue-property-decorator';
import NotificationsManager from '@/components/NotificationsManager.vue';
import { readIsLoggedIn, readUserProfile } from '@/store/main/getters';
import { dispatchCheckLoggedIn } from '@/store/main/actions';
import { commitSetInactivityLocked } from '@/store/main/mutations';
import { getLastActivity } from '@/utils';
import CookieLaw from 'vue-cookie-law'
import { appName } from '@/env';
import DialogController from '@/features/dialog/components/DialogController.vue';
import { InactivityLockDialog } from '@/features/inactivity-lock';
import { applyTheme, getStoredTheme } from '@/features/theme';

@Component({
  components: {
    NotificationsManager,
    CookieLaw,
    DialogController,
    InactivityLockDialog,
  },
})
export default class App extends Vue {
  public appName = appName;
  private inactivityTimer: number | null = null;

  get loggedIn() {
    return readIsLoggedIn(this.$store);
  }

  // Each account keeps its own theme; apply it as soon as we know who is logged in
  @Watch('userEmail')
  public onUserEmailChange(email?: string) {
    if (email) {
      applyTheme(getStoredTheme(email));
    }
  }

  get userEmail() {
    return readUserProfile(this.$store)?.email;
  }

  public async created() {
    await dispatchCheckLoggedIn(this.$store);
    this.inactivityTimer = window.setInterval(() => this.checkInactivity(), 60_000);
  }

  public beforeDestroy() {
    if (this.inactivityTimer !== null) {
      clearInterval(this.inactivityTimer);
    }
  }

  private checkInactivity() {
    const profile = readUserProfile(this.$store);
    const limitMinutes = profile?.setting_lock_inactive_minutes;
    const userEmail = profile?.email;
    if (!limitMinutes || !userEmail) return;

    const lastActivity = getLastActivity(userEmail);
    if (lastActivity && (Date.now() - lastActivity) / 60000 > limitMinutes) {
      commitSetInactivityLocked(this.$store, true);
    }
  }
}
